<template>
  <div class="container account intro-section" :class="{'intro-section--powered-by': showPoweredBy}">
    <div class="row d-lg-flex align-items-center">
      <div class="col-lg-12" v-if="showPoweredBy">
        <PoweredBy :as-logo="thirdLevelDomain.includes('photos')"/>
      </div>
      <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xxl-4 offset-xxl-4 intro-section__headline">
        <div class="intro-section__headline__image d-block">
          <router-link :to="{ name: 'homepage' }">
            <Transition name="fade">
              <img v-if="getAppConfigReady" :src="$store.getters['appConfig/getAppLogo']" alt="Logo">
            </Transition>
          </router-link>
        </div>

        <h1 class="intro-section__headline__title">
          <slot name="title"></slot>
        </h1>

        <h4 class="intro-section__headline__txt">
          <slot name="subtitle"></slot>
        </h4>
      </div>
      <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3 col-xxl-4 offset-xxl-4">
        <slot name="mainContent"></slot>
      </div>
      <slot name="bottomContent"></slot>
    </div>
  </div>
</template>


<script>
import {mapGetters} from "vuex";
import PoweredBy from "@/components/PoweredBy.vue";

export default {
  components: {PoweredBy},
  computed: {
    ...mapGetters(['isPicaThirdLevelDomain', 'thirdLevelDomain']),
    ...mapGetters('appConfig', [
      'getAppConfigReady',
      'getHidePoweredByLogo',
    ]),
    showPoweredBy() {
      return this.getAppConfigReady && !this.getHidePoweredByLogo && !this.isPicaThirdLevelDomain
    }
  }
}
</script>
